import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { EmployeeCreationTypeEnum } from '@thinknet-gmbh/platform-common';
import { PageLayout, Typography, TYPOGRAPHY_SIZE } from '@thinknet-gmbh/platform-common-ui';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';
import { useCreateEmployeeQuestionnaire } from 'src/hooks/employee-questionnaire/create-employee-questionnaire.hook';

import { EmployeeByQuestionnaireForm } from './components/employee-by-questionnaire-form';
import { CreateEmployeeWrapper } from './create-employee-by-questionnaire.styles';
import { ICreateEmployeeFormInitialValue } from './create-employee-by-questionnaire.interfaces';

const CreateEmployeeByQuestionnaire = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(['common', 'employee']);

  const currentCompanyId = useGetCurrentCompanyId();
  const { createEmployeeQuestionnaire, loading } = useCreateEmployeeQuestionnaire({
    onSuccess: () => navigate(ROUTES.employee),
  });

  const initialValues = {
    companyId: currentCompanyId || '',
    jobCompanyId: currentCompanyId || '',
    creationType: EmployeeCreationTypeEnum.questionnaire,
    questionnaireSettingsId: '',
    departmentId: '',
    jobId: '',
    jobLocationId: '',
    responsiblePersonsIds: [],
    firstName: '',
    lastName: '',
    email: '',
  };

  const onFinish = (values: ICreateEmployeeFormInitialValue) => {
    const { firstName, email, lastName, ...rest } = values;

    createEmployeeQuestionnaire({
      variables: {
        payload: {
          ...rest,
          companyId: currentCompanyId,
          employeePersonalInfo: {
            firstName,
            lastName,
            email,
          },
        },
      },
    });
  };

  return (
    <PageLayout pageTitle="Add new employee">
      <CreateEmployeeWrapper>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('employee:questionnaire.labels.addNewTitle')}
        </Typography>
        <EmployeeByQuestionnaireForm
          loading={loading}
          initialValues={initialValues}
          onFinish={onFinish}
        />
      </CreateEmployeeWrapper>
    </PageLayout>
  );
};

export default CreateEmployeeByQuestionnaire;
